/**
 * MyBranchPage
 * Redirects branch_admin to their assigned branch's detail page.
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2, AlertCircle } from 'lucide-react';

const MyBranchPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check multiple possible field names for branch ID
    const branchId = user?.current_branch_id || user?.branch_id || user?.currentBranchId;
    
    console.log('MyBranchPage: User object:', user);
    console.log('MyBranchPage: Branch ID found:', branchId);
    
    if (branchId) {
      navigate(`/branches/${branchId}`, { replace: true });
    } else if (user) {
      // User is loaded but no branch assigned
      setError('No branch assigned to your account. Please contact an administrator.');
    }
  }, [user, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-theme-primary flex items-center justify-center p-4">
        <div className="text-center max-w-md">
          <AlertCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-theme-primary mb-2">Branch Not Assigned</h2>
          <p className="text-theme-secondary mb-4">{error}</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 bg-accent-gold text-black font-medium rounded-lg hover:bg-accent-gold/90"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-theme-primary flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-accent-gold animate-spin mx-auto mb-4" />
        <p className="text-theme-secondary">Loading your branch...</p>
      </div>
    </div>
  );
};

export default MyBranchPage;
